module.exports = __webpack_public_path__ + "img/cooperation05.fedd5411.png";